import * as React from "react";
export const Dropdown = ({ query, setQuery }) => {
  const [isOpen, setOpen] = React.useState(false);

  const dropdownItems = [
    {
      id: "angular",
      label: "Angular",
      image: "https://www.svgrepo.com/show/373427/angular.svg",
    },
    {
      id: "reactjs",
      label: "Reactjs",
      image: "https://www.svgrepo.com/show/374032/reactjs.svg",
    },
    {
      id: "vuejs",
      label: "Vuejs",
      image: "https://www.svgrepo.com/show/349557/vue.svg",
    },
  ];

  const toggleDropdown = () => setOpen(!isOpen);

  const handleItemClick = (id) => {
    query !== id && setQuery(id);
  };
  return (
    <div className="dropdown">
      <div className="dropdown-header" onClick={toggleDropdown}>
        {query
          ? dropdownItems.find((item) => item.id === query).label
          : "Select your news"}
        <i className={`fa fa-chevron-right icon ${isOpen && "open"}`}></i>
      </div>
      <div className={`dropdown-body ${isOpen && "open"}`}>
        {dropdownItems.map((item) => (
          <div
            key={item.id}
            className={`dropdown-item  ${item.id === query && "selected"}`}
            onClick={(e) => handleItemClick(e.target.id)}
            id={item.id}
          >
            <span
              className={`dropdown-item-dot ${item.id === query && "selected"}`}
            >
              👉{" "}
            </span>
            <img src={item.image} alt="" />

            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};
